import { render, staticRenderFns } from "./createProductsSec.vue?vue&type=template&id=10c1ecb2&scoped=true"
import script from "./createProductsSec.vue?vue&type=script&lang=js"
export * from "./createProductsSec.vue?vue&type=script&lang=js"
import style0 from "./createProductsSec.vue?vue&type=style&index=0&id=10c1ecb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c1ecb2",
  null
  
)

export default component.exports